module.exports = __webpack_public_path__ + "static/media/mobile workshop.3f253e02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/ApiForBusiness/mobile workshop.png
// module id = 47
// module chunks = 0